import { render, staticRenderFns } from "./TesimonialsCard.vue?vue&type=template&id=2ca77c90&scoped=true&"
import script from "./TesimonialsCard.vue?vue&type=script&lang=js&"
export * from "./TesimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./TesimonialsCard.vue?vue&type=style&index=0&id=2ca77c90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca77c90",
  null
  
)

export default component.exports